export default {
  SET_POPUP_PERSONALITY: (state, payload) => {
    state.alreadySeePopupPersonality = payload
  },
  SET_PREVIOUS_LANGUAGE: (state, payload) => {
    state.previousLanguage = payload
  }
}
